import React from 'react';
import PropTypes from 'prop-types';

function PageWrapper({ children }) {
    return (
        <div className="row">
            <div className="col col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                {children}
            </div>
        </div>
    );
}

PageWrapper.propTypes = {
    children: PropTypes.node.isRequired,
};

export default PageWrapper;
